export const messages = {
    "baseform.actions.button.clean": "Limpiar",
    "baseform.actions.button.save": "Guardar",
    "basecrud.actions.button.edit": "Modificar",
    "basecrud.actions.button.delete": "Eliminar",
    "basecrud.actions.button.new": "Nuevo",
    "basecrud.actions.button.search": "Buscar",
    "basecrud.confirm.delete.title": "Confirmación",
    "basecrud.confirm.save.title.success": "Confirmación",
    "basecrud.confirm.edit.title.success": "Confirmación",
    "basecrud.confirm.delete.title.success": "Confirmación",
    "confirm.button.yes": "Si",
    "confirm.button.no": "No",
    "basecrud.table.link.next": "Cargar las siguientes ?1 filas",
    "baseservice.msg.default.exception.summary": "Exception",
    "baseservice.msg.default.unauthorized.summary": "Acceso denegado",
    "baseservice.msg.default.unauthorized.detail": "No tiene permisos para realizar esta petición",
    "baseservice.msg.default.error.summary": "Exception",
    "baseservice.msg.default.error.detail": "Ha ocurrido un error al procesar la petición"

    ,


    "administration.ahorro.form.title": "Formulario de ahorro",
    "administration.ahorro.form.save.msg.success": "Ahorro creado correctamente",
    "administration.ahorro.form.edit.msg.success": "Ahorro editado correctamente",
    "administration.ahorro.form.delete.msg.success": "Ahorro eliminado correctamente",
    "administration.ahorro.search.form.title": "Formulario de ahorro",
    "administration.ahorro.search.table.title": "Resultados de búsqueda",
    "administration.ahorro.confirm.delete.msg": "¿Desea eliminar el ahorro ?1?",

    "administration.banner.form.title": "Formulario de banner",
    "administration.banner.form.save.msg.success": "Banner creado correctamente",
    "administration.banner.form.edit.msg.success": "Banner editado correctamente",
    "administration.banner.form.delete.msg.success": "Banner eliminado correctamente",
    "administration.banner.search.form.title": "Formulario de banner",
    "administration.banner.search.table.title": "Resultados de búsqueda",
    "administration.banner.confirm.delete.msg": "¿Desea eliminar el banner ?1?",

    "administration.calendario.form.title": "Formulario de calendario",
    "administration.calendario.form.save.msg.success": "Calendario creado correctamente",
    "administration.calendario.form.edit.msg.success": "Calendario editado correctamente",
    "administration.calendario.form.delete.msg.success": "Calendario eliminado correctamente",
    "administration.calendario.search.form.title": "Formulario de calendario",
    "administration.calendario.search.table.title": "Resultados de búsqueda",
    "administration.calendario.confirm.delete.msg": "¿Desea eliminar el calendario ?1?",

    "administration.credito.form.title": "Formulario de credito",
    "administration.credito.form.save.msg.success": "Credito creado correctamente",
    "administration.credito.form.edit.msg.success": "Credito editado correctamente",
    "administration.credito.form.delete.msg.success": "Credito eliminado correctamente",
    "administration.credito.search.form.title": "Formulario de credito",
    "administration.credito.search.table.title": "Resultados de búsqueda",
    "administration.credito.confirm.delete.msg": "¿Desea eliminar el credito ?1?",

    "administration.empresas.form.title": "Formulario de empresas",
    "administration.empresas.form.save.msg.success": "Empresas creado correctamente",
    "administration.empresas.form.edit.msg.success": "Empresas editado correctamente",
    "administration.empresas.form.delete.msg.success": "Empresas eliminado correctamente",
    "administration.empresas.search.form.title": "Formulario de empresas",
    "administration.empresas.search.table.title": "Resultados de búsqueda",
    "administration.empresas.confirm.delete.msg": "¿Desea eliminar el empresas ?1?",

    "administration.evento.form.title": "Formulario de evento",
    "administration.evento.form.save.msg.success": "Evento creado correctamente",
    "administration.evento.form.edit.msg.success": "Evento editado correctamente",
    "administration.evento.form.delete.msg.success": "Evento eliminado correctamente",
    "administration.evento.search.form.title": "Formulario de evento",
    "administration.evento.search.table.title": "Resultados de búsqueda",
    "administration.evento.confirm.delete.msg": "¿Desea eliminar el evento ?1?",

    "administration.foto.form.title": "Formulario de foto",
    "administration.foto.form.save.msg.success": "Foto creado correctamente",
    "administration.foto.form.edit.msg.success": "Foto editado correctamente",
    "administration.foto.form.delete.msg.success": "Foto eliminado correctamente",
    "administration.foto.search.form.title": "Formulario de foto",
    "administration.foto.search.table.title": "Resultados de búsqueda",
    "administration.foto.confirm.delete.msg": "¿Desea eliminar el foto ?1?",

    "administration.medico.form.title": "Formulario de medico",
    "administration.medico.form.save.msg.success": "Medico creado correctamente",
    "administration.medico.form.edit.msg.success": "Medico editado correctamente",
    "administration.medico.form.delete.msg.success": "Medico eliminado correctamente",
    "administration.medico.search.form.title": "Formulario de medico",
    "administration.medico.search.table.title": "Resultados de búsqueda",
    "administration.medico.confirm.delete.msg": "¿Desea eliminar el medico ?1?",

    "administration.noticia.form.title": "Formulario de noticia",
    "administration.noticia.form.save.msg.success": "Noticia creado correctamente",
    "administration.noticia.form.edit.msg.success": "Noticia editado correctamente",
    "administration.noticia.form.delete.msg.success": "Noticia eliminado correctamente",
    "administration.noticia.search.form.title": "Formulario de noticia",
    "administration.noticia.search.table.title": "Resultados de búsqueda",
    "administration.noticia.confirm.delete.msg": "¿Desea eliminar el noticia ?1?",

    "administration.participante.form.title": "Formulario de participante",
    "administration.participante.form.save.msg.success": "Participante creado correctamente",
    "administration.participante.form.edit.msg.success": "Participante editado correctamente",
    "administration.participante.form.delete.msg.success": "Participante eliminado correctamente",
    "administration.participante.search.form.title": "Formulario de participante",
    "administration.participante.search.table.title": "Resultados de búsqueda",
    "administration.participante.confirm.delete.msg": "¿Desea eliminar el participante ?1?",

    "administration.documento.form.title": "Formulario de documento",
    "administration.documento.form.save.msg.success": "documento creado correctamente",
    "administration.documento.form.edit.msg.success": "documento editado correctamente",
    "administration.documento.form.delete.msg.success": "documento eliminado correctamente",
    "administration.documento.search.form.title": "Formulario de documento",
    "administration.documento.search.table.title": "Resultados de búsqueda",
    "administration.documento.confirm.delete.msg": "¿Desea eliminar el documento?",

  
};



// WEBPACK FOOTER //
// ./src/app/util/message.constants.ts